import React from "react";
import "./DriverLogViewPager.css";
import { parseISO } from "date-fns";
import { RouteComponentProps } from "react-router-dom";
import resourceNames from "../../../../common/data/resourceNames";
import { DriverLogDetailedView } from "../../../../common/data/service-proxies";
import { DatePager } from "../../../common/mui-inputs/DatePager";
import { ThemeProvider } from "@material-ui/styles";
import { Theme, useTheme } from "@material-ui/core";

interface Props extends Partial<RouteComponentProps> {
  record: DriverLogDetailedView;
  loading: boolean;
}

export const DriverLogViewPager = ({ record, loading, history }: Props) => {
  const theme: Theme = useTheme();

  if (!record.date) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <div id="driver-log-view-pager">
        <DatePager
          firstDate={record.firstEventTime ?? undefined}
          loading={loading}
          value={parseISO(record.date)}
          onSetCurrentDate={(date) => {
            history?.push(
              `/${resourceNames.HOS_DRIVER_LOG_VIEW}/${
                record.driverId
              }/${date.toISOString()}`
            );
          }}
          previousEnabled={!!record.previousLogDate}
          nextEnabled={!!record.nextLogDate}
          previousOnClick={() => {
            history?.push(
              `/${resourceNames.HOS_DRIVER_LOG_VIEW}/${record.driverId}/${record.previousLogDate}`
            );
          }}
          nextOnClick={() => {
            history?.push(
              `/${resourceNames.HOS_DRIVER_LOG_VIEW}/${record.driverId}/${record.nextLogDate}`
            );
          }}
        />
      </div>
    </ThemeProvider>
  );
};
